<button mat-stroked-button [disabled]="disabled()" (focus)="focusEvent.emit($event)" (blur)="blurEvent.emit($event)">
  <div class="icon-container">
    <ideal-lottie icon src="assets/icons/magnify.json" speed="3" (loaded)="lottieLoaded()"></ideal-lottie>
    <!-- <ideal-lottie icon src="assets/icons/search-icon.json" speed="3" (loaded)="lottieLoaded()"></ideal-lottie> -->
  </div>
</button>
